import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Flex, Progress, Typography } from 'antd'
import { FC, useMemo } from 'react'
import classes from './ProgressHeader.module.css'

type ProgressHeaderProps = {
  title: string;
  onBack: () => void;
  sectionIndex: number;
  last: number;
  description: string;
}

export const ProgressHeader: FC<ProgressHeaderProps> = ({ title, onBack, sectionIndex, last, description }) => {
  const percent = useMemo(() => ((sectionIndex + 1) / (last + 1)) * 100, [sectionIndex, last]);

  return (
    <div className={classes.progressHeader}>
      <Flex vertical gap={8} className={classes.headerContainer}>
        <Flex align='center' className={classes.titleContainer}>
          {sectionIndex > 0 && (
            <Button 
              className={classes.backButton}
              ghost 
              type='link' 
              size='small' 
              onClick={onBack}
            >
              <ArrowLeftOutlined style={{ color: '#000', fontSize: 24 }} />
            </Button>
          )}
          <Typography.Title level={2} className={classes.title}>{title}</Typography.Title>
        </Flex>
        <Typography.Text className={classes.description}>{description}</Typography.Text>
        <Progress className={classes.progress} showInfo={false} percent={percent} />
      </Flex>
    </div>
  )
}